import { render, staticRenderFns } from "./SegTablaPostulante.vue?vue&type=template&id=145ef6f4&scoped=true&"
import script from "./SegTablaPostulante.vue?vue&type=script&lang=js&"
export * from "./SegTablaPostulante.vue?vue&type=script&lang=js&"
import style0 from "./SegTablaPostulante.vue?vue&type=style&index=0&id=145ef6f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145ef6f4",
  null
  
)

export default component.exports